import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ColorContext from '@providers/ColorProvider/context/ColorContext';
import { ReactNode, useContext } from 'react';

interface Props {
    children?: ReactNode;
    warmIcon?: ReactNode;
    coolIcon?: ReactNode;
    fit?: boolean;
}

function BlankContainer({
    children, warmIcon, coolIcon, fit,
}:Props) {
    const { grayTheme } = useContext(ColorContext);
    return (
        <Container align='center'
            fit={fit}
            fullWidth
            justify='center'
            spacing={4}>
            {grayTheme === 'WARM' ? warmIcon : coolIcon}
            <Text color={colors.textSecondary}>
                {children}
            </Text>
        </Container>
    );
}

const Container = styled(Column, {
    shouldForwardProp: (prop) => prop !== 'fit',
})<{
    fit?: boolean;
}>`
    min-height: ${({ fit }) => (fit ? 'unset' : '50vh')};
`;

export default BlankContainer;
